<div class="flex-content" #flexContent>
<div class="chart-container">
    <ngx-charts-line-chart style="height: 300px; min-width: 480px; max-width:650px; display: block;"
      (window:resize)="onResize()"
      [autoScale]="true"
      [view]="view"
      [results]="data"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [legend]="legend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [yAxisLabel]="yAxisLabel"
      [scheme]="colorScheme"
      >
  </ngx-charts-line-chart>
</div>
</div>